<script lang="ts" setup>
import { ref, provide } from 'vue';
import ButtonComp from './ButtonComp.vue';
import { nullsetterListenerSymbol } from '@/composeables/loaders/nullsetterListener';

const props = defineProps<{
    nullable: boolean;
    buttonClass?: string;
}>();

const model = defineModel();

const clear = () => {
    model.value = null;
    nullableTriggerToggler.value = !nullableTriggerToggler.value;
};

const nullableTriggerToggler = ref(false);

// This is provided for the UseNullSetterListener specifically but it will be available for everything, which is annoying
// Maybe provide/inject is the wrong tool for the job here
provide(nullsetterListenerSymbol, nullableTriggerToggler);
</script>

<template>
    <div class="input-group flex-nowrap">
        <slot></slot>
        <ButtonComp
            button-type="Custom"
            icon="fa-xmark"
            class="btn-outline-secondary"
            :class="buttonClass"
            v-if="nullable"
            @click="clear"
        />
    </div>
</template>
